import React, { ReactElement } from 'react';
import { useGoogleLogin } from '@hooks/auth';
import { Button } from 'antd';

interface LoginFormProps {
  showLoading?: boolean;
  extra?: string | ReactElement;
  loading?: boolean;
  showMessage?: string;
  message?: string;
}

const GoogleLogin = (props: LoginFormProps) => {
  const googleLogin = useGoogleLogin();

  const handleOnClickGoogleLogin = async (
    e: React.MouseEvent<HTMLButtonElement>,
  ) => {
    e.preventDefault();

    googleLogin();
  };

  return (
    <div className="d-flex justify-content-center mt-3">
      <Button
        type="primary"
        size="large"
        onClick={handleOnClickGoogleLogin}
        style={{
          width: '100%',
          maxWidth: '400px',
          height: '56px',
          backgroundColor: '#3B65E8',
          borderColor: '#3B65E8',
          borderRadius: '8px',
          fontSize: '16px',
          fontWeight: 500,
          position: 'relative',
          padding: 0,
        }}
      >
        <div
          style={{
            position: 'absolute',
            left: '16px',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '32px',
            height: '32px',
            backgroundColor: '#ffffff',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src="/img/svg/ico-google.svg"
            alt="Google"
            style={{ width: '20px', height: '20px' }}
          />
        </div>
        <div
          style={{
            width: '100%',
            textAlign: 'center',
          }}
        >
          구글 계정으로 로그인 하기
        </div>
      </Button>
    </div>
  );
};

export default GoogleLogin;
